var _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBirdyPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 889,
    height: 889,
    viewBox: "0 0 889 889",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M769.643 480L769.643 660M859 570.643H679",
    stroke: "currentColor",
    strokeWidth: 48,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 301.5C29.5686 301.887 29.6374 302.274 29.7064 302.661M29.7064 302.661C121.328 815.225 670.533 648.132 661.04 316.882C661 122.5 409 104.718 360.5 254.5C291.368 468 128.789 379.636 29.7064 302.661ZM29.7064 302.661C29.6376 302.607 29.5688 302.554 29.5 302.5M675.618 289.39L715 261M676.703 316.882L719.5 339M304.5 639.5V735.5M374.5 639.5V735.5",
    stroke: "currentColor",
    strokeWidth: 48,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 559.5,
    cy: 295.5,
    r: 12.5,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 48
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirdyPlus);
export default __webpack_public_path__ + "static/media/birdy-plus.54fc2f0ce2e6459884015469410e79da.svg";
export { ForwardRef as ReactComponent };